<ng-container *ngIf="overDueEmiLabel">
    <div class="alert-card danger-alert-card mb-10">
        <img class="alert-card-icon" src="assets/svg/icons/info-warn-diamond-fill.svg" alt="alert-icon" />
        <h4 class="alert-card-desc">You’ve missed your EMI repayment, your Klinq points have been forfeited</h4>
    </div>
</ng-container>

<ng-container *ngIf="discount > 0 && !isWaiverApplied">
    <div class="alert-card secondary-alert-card mb-10">
        <img class="alert-card-icon" src="assets/svg/icons/badge-percent-fill-gb.svg" alt="alert-icon" />
        <h4 class="alert-card-desc">
            <span class="text-primary-50">Foreclose your loan early & </span>
            <span>
                Save {{ discount | defaultBlank: "number" : { symbol: "₹", position: "before" } }} on interest
            </span>
        </h4>
    </div>
</ng-container>
